//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[[],"CreateConfigurationContextBuilder",{R_:{builder:"PDM.ConfigurationContextBuilder"}},0,0],[["part","objects"],"CreateEffectivityAttributePropertiesBuilder",{R_:{builder:"PDM.EffectivityAttributePropertiesBuilder"}},2,0],[["part"],"CreateVariantRulesConfigurationBuilder",{R_:{builder:"PDM.VariantRulesConfigurationBuilder"}},1,1],[[],"CreateConfigurationContextBuilderForMultiConfig",{R_:{builder:"PDM.ConfigurationContextBuilder"}},0,0],[["worksetPart","subsetPartOcc"],"CreateDesignWorksetProductConfigurationContextBuilder",{R_:{builder:"PDM.ConfigurationContextBuilder"}},2,0]],[]];
SPLM.PDM.ConfigurationManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.PDM.ConfigurationManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;